/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DropYouTubeVideoResponse } from './DropYouTubeVideoResponse';
import {
    DropYouTubeVideoResponseFromJSON,
    DropYouTubeVideoResponseFromJSONTyped,
    DropYouTubeVideoResponseToJSON,
    DropYouTubeVideoResponseToJSONTyped,
} from './DropYouTubeVideoResponse';

/**
 * 
 * @export
 * @interface DropYouTubeVideosResponse
 */
export interface DropYouTubeVideosResponse {
    /**
     * 
     * @type {string}
     * @memberof DropYouTubeVideosResponse
     */
    channelId: string | null;
    /**
     * 
     * @type {Array<DropYouTubeVideoResponse>}
     * @memberof DropYouTubeVideosResponse
     */
    videos: Array<DropYouTubeVideoResponse>;
    /**
     * 
     * @type {number}
     * @memberof DropYouTubeVideosResponse
     */
    computedAt: number;
}

/**
 * Check if a given object implements the DropYouTubeVideosResponse interface.
 */
export function instanceOfDropYouTubeVideosResponse(value: object): value is DropYouTubeVideosResponse {
    if (!('channelId' in value) || value['channelId'] === undefined) return false;
    if (!('videos' in value) || value['videos'] === undefined) return false;
    if (!('computedAt' in value) || value['computedAt'] === undefined) return false;
    return true;
}

export function DropYouTubeVideosResponseFromJSON(json: any): DropYouTubeVideosResponse {
    return DropYouTubeVideosResponseFromJSONTyped(json, false);
}

export function DropYouTubeVideosResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropYouTubeVideosResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'channelId': json['channelId'],
        'videos': ((json['videos'] as Array<any>).map(DropYouTubeVideoResponseFromJSON)),
        'computedAt': json['computedAt'],
    };
}

export function DropYouTubeVideosResponseToJSON(json: any): DropYouTubeVideosResponse {
    return DropYouTubeVideosResponseToJSONTyped(json, false);
}

export function DropYouTubeVideosResponseToJSONTyped(value?: DropYouTubeVideosResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'channelId': value['channelId'],
        'videos': ((value['videos'] as Array<any>).map(DropYouTubeVideoResponseToJSON)),
        'computedAt': value['computedAt'],
    };
}

